






import { vueWith } from "./../vueWith"


/** 外部公開用 親から呼び出すことを想定 */
export interface MessageComponentMethods {
  /**  */
  show: (msg: string, wait?: number, error?: boolean) => void
}

/**
 * @example
 *  <message-component
 *    v-model="message"
 *    class="select"
 *    v-bind:class="{ none: radio == 1 || frequency != 1 }"
 *  ></message-component>
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    //
  },
  data() {
    return {
      message: "",
      isActive: false,
      error: false,
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    //
  },

  methods: {


    // 子から呼ばれる ---------------------------------------------

    show(msg: string, wait = 1000, error = false) {
      this.message = msg
      this.isActive = true
      this.error = error
      setTimeout(() => {
        this.isActive = false
      }, wait)
    },

  },
})


